import './FineTuningSettingInformation.css'
import { FineTuningSettingInformationProps } from './FineTuningSettingInformation.types'

export const FineTuningSettingInformation = ({
	topMargin,
	information,
	header,
}: FineTuningSettingInformationProps) => {
	return (
		<div className='fine-tuning-setting-information' style={{ top: topMargin }}>
			<div className='fine-tuning-setting-information-header'>
				<img src="./icons/24px/information.svg" alt="information" />
				<p className='fine-tuning-setting-information-header-text'>{header}</p>
			</div>

			<div className='fine-tuning-setting-information-body'>
				<p className='fine-tuning-setting-information-body-text'>
					{information}
				</p>
			</div>

		</div>
	)
}